"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var PlayerState_1 = __importDefault(require("../constants/PlayerState"));

var withTheme_1 = __importDefault(require("../utils/withTheme"));

var Img_1 = __importDefault(require("./Img"));

var SafeAsyncComponent_1 = __importDefault(require("./SafeAsyncComponent"));

var Poster =
/** @class */
function (_super) {
  __extends(Poster, _super);

  function Poster() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Poster.prototype.shouldComponentUpdate = function (nextProps) {
    return this.props.autoPlay !== nextProps.autoPlay || this.props.autoPlayWasBlocked !== nextProps.autoPlayWasBlocked || this.props.loop !== nextProps.loop || this.props.playerState !== nextProps.playerState || this.props.src !== nextProps.src;
  };

  Poster.prototype.render = function () {
    var _a = this.props,
        src = _a.src,
        loop = _a.loop,
        playerState = _a.playerState,
        autoPlay = _a.autoPlay,
        autoPlayWasBlocked = _a.autoPlayWasBlocked;

    if (!src) {
      return null;
    }

    var visible = (playerState === PlayerState_1["default"].STOPPED || playerState === PlayerState_1["default"].LOADING || playerState === PlayerState_1["default"].LOADED || playerState === PlayerState_1["default"].ENDED && !loop) && (
    /*
        When autoplay is set, the poster should only be visible
        if the player state is ENDED
    */
    !autoPlay || autoPlayWasBlocked || playerState === PlayerState_1["default"].ENDED);
    return withTheme_1["default"](this.context.theme, {
      poster: true,
      'poster--is-hidden': !visible
    })(React.createElement("div", {
      "aria-hidden": "true"
    }, withTheme_1["default"](this.context.theme, 'poster__content')(React.createElement(Img_1["default"], {
      src: this.props.src
    }))));
  };

  Poster.contextTypes = __assign({}, SafeAsyncComponent_1["default"].contextTypes, {
    theme: PropTypes.object
  });
  return Poster;
}(SafeAsyncComponent_1["default"]);

exports["default"] = Poster;